<div #changeLogContainerRef class="ag-changes-history__container">
  <dx-data-grid
    #changeLogGridRef
    class="ag-changes-history__grid"
    [dataSource]="dataSource"
    [showBorders]="false"
    [remoteOperations]="true"
    [syncLookupFilterValues]="false"
    [columnAutoWidth]="true"
    [scrollLeft]="true"
    [allowColumnReordering]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [focusedRowEnabled]="false"
    [focusedColumnIndex]="0"
    [autoNavigateToFocusedRow]="false"
    height="100%"
    (onRowPrepared)="onRowPrepared($event)"
    (onOptionChanged)="onOptionChanged($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
  >
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-builder [allowHierarchicalFields]="true"></dxo-filter-builder>
    <dxo-filter-builder-popup></dxo-filter-builder-popup>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
    <dxo-scrolling mode="virtual" rowRenderingMode="virtual"></dxo-scrolling>

    <dxo-toolbar>
      <dxi-item name="searchPanel"></dxi-item>

      <dxi-item location="after">
        <div *dxTemplate>
          <button
            type="button"
            class="btn btn-default waves-effect"
            data-toggle="fullscreen"
            (click)="fullscreen(changeLogContainerRef)"
          >
            <i class="dx-icon dx-icon-agi-up-right-and-down-left-from-center"></i>
          </button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxi-column dataField="date" dataType="datetime" [format]="dateFormat" [sortOrder]="'desc'"></dxi-column>

    <dxi-column
      dataField="collection"
      caption="Collection"
      [allowFiltering]="true"
      [visible]="false"
      [filterValues]="collectionFilterValues"
    ></dxi-column>

    <dxi-column
      dataField="action"
      [visible]="changeLogTypeSig() !== ChangeLogsHistoryType.agent"
      [minWidth]="150"
    >
      <dxo-lookup
        [dataSource]="DOCUMENT_WRITE_ACTION_LOOKUP"
        [displayExpr]="LookupKeys.description"
        [valueExpr]="LookupKeys.value"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="updatedBy"
      caption="Who Change"
      [allowFiltering]="true"
      [allowSearch]="true"
      [minWidth]="200"
      cellTemplate="updatedByCellTemplate"
    >
      <dxo-lookup
        [dataSource]="agentsLookupSig()"
        [allowClearing]="true"
        [displayExpr]="LookupKeys.description"
        [valueExpr]="LookupKeys.value"
      >
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="changedBySource"
      caption="Change Source"
      [width]="200"
      [allowFiltering]="true"
      [allowSearch]="true"
    >
      <dxo-lookup
        [dataSource]="changeSourceTypeLookup"
        [valueExpr]="LookupKeys.value"
        [displayExpr]="LookupKeys.description"
        [allowClearing]="true"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="updatedFields"
      caption="Updated Fields"
      dataType="string"
      cellTemplate="updatedFieldsCellTemplate"
      [filterOperations]="['contains']"
      [calculateFilterExpression]="updatedFieldsCalcFilterExpr"
    ></dxi-column>

    <dxi-column
      dataField="wasabiPath"
      caption="Wasabi Data"
      [allowFiltering]="true"
      [visible]="false"
      [filterValues]="wasabiPathFilterValues"
    ></dxi-column>

    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
    <div *dxTemplate="let masterDetails of 'detail'">
      @if (masterDetails.data; as data) {
        @switch (changeLogTypeSig()) {
          @case (ChangeLogsHistoryType.agent) {
            @if (data.documentIds?.agentDbId; as agentDbId) {
              @if (data.wasabiPath | wasabiFile | changeLogsDiff: !!agentDbId | async; as changeLogsData) {
                @if (changeLogsData?.['diff']; as changeLogs) {
                  @switch (data?.updatedFields[0]) {
                    <!-- Email Address-->
                    @case (LoggedCollections.agentEmailAddress) {
                      <ng-container
                        *var="changeLogsData?.['oldData']?.[EmailAddressKeys.address] as agentEmailAddress">
                        @switch (data.action) {
                          @case (DocumentWriteAction.remove) {
                            <p class="fw-bold">
                              Email Address "{{ agentEmailAddress }}" was removed.
                            </p>
                          }
                          @case (DocumentWriteAction.create) {
                            <p class="fw-bold">
                              Email Address "{{ changeLogs[1]?.[EmailAddressKeys.address] }}" was created.
                            </p>
                            @if (getChangedLog(changeLogs) | logsByKey: EMAIL_ADDRESS_SEARCH_KEYS_CONFIG; as logs) {
                              <ag-crm-agent-info-change-log [changeLogs]="logs"></ag-crm-agent-info-change-log>
                            }
                          }
                          @default {
                            <p class="fw-bold">Email Address {{ agentEmailAddress }} was updated.</p>
                            @if (changeLogs | logsByKey: EMAIL_ADDRESS_SEARCH_KEYS_CONFIG; as logs) {
                              <ag-crm-agent-info-change-log [changeLogs]="logs"></ag-crm-agent-info-change-log>
                            }
                          }
                        }
                      </ng-container>
                    }
                    <!-- Associations -->
                    @case (LoggedCollections.agentAssociations) {
                      <ng-container
                        *var="[changeLogsData?.['oldData']?.[AssociationKeys.firstName], changeLogsData?.['oldData']?.[AssociationKeys.lastName]] | fullName as agentName">
                        @switch (data.action) {
                          @case (DocumentWriteAction.remove) {
                            <p class="fw-bold">
                              Association for "{{ agentName }}" was removed.
                            </p>
                          }
                          @case (DocumentWriteAction.create) {
                            <p class="fw-bold">
                              Association for "{{ agentName }}" was created.
                            </p>
                            @if (getChangedLog(changeLogs) | logsByKey: ASSOCIATIONS_SEARCH_KEYS_CONFIG; as logs) {
                              <ag-shr-agent-associations-info-log-details
                                [changeLogs]="logs"
                                [oldData]="changeLogsData?.['oldData']"
                              ></ag-shr-agent-associations-info-log-details>
                            }
                          }
                          @default {
                            <p class="fw-bold">Association for "{{ agentName }}" was updated.</p>
                            @if (changeLogs | logsByKey: ASSOCIATIONS_SEARCH_KEYS_CONFIG; as logs) {
                              <ag-shr-agent-associations-info-log-details
                                [changeLogs]="logs"
                                [oldData]="changeLogsData?.['oldData']"
                              ></ag-shr-agent-associations-info-log-details>
                            }
                          }
                        }
                      </ng-container>
                    }
                    <!-- Signed Policies-->
                    @case (LoggedCollections.policySigners) {
                      @switch (data.action) {
                        @case (DocumentWriteAction.remove) {
                          <p class="fw-bold">
                            Policy was removed.
                          </p>
                        }
                        @case (DocumentWriteAction.create) {
                          @if (getChangedLog(changeLogs) | logsByKey: POLICY_SIGNERS_SEARCH_KEYS_CONFIG; as logs) {
                            <ag-crm-agent-info-change-log [changeLogs]="logs"></ag-crm-agent-info-change-log>
                          }
                        }
                        @default {
                          <p class="fw-bold">Policy was signed.</p>
                        }
                      }
                    }
                    <!--Agent-->
                    @default {
                      @switch (data.action) {
                        @case (DocumentWriteAction.remove) {
                          <p class="fw-bold">
                            Agent "{{
                              [changeLogs[0]?.[AgentKeys.p_agent_first_name], changeLogs[0]?.[AgentKeys.p_agent_last_name]]
                                | fullName
                            }}" was removed.
                          </p>
                        }
                        @case (DocumentWriteAction.create) {
                          <p class="fw-bold">
                            Agent "{{
                              [changeLogs[1]?.[AgentKeys.p_agent_first_name], changeLogs[1]?.[AgentKeys.p_agent_last_name]]
                                | fullName
                            }}" was created.
                          </p>
                          @if (getChangedLog(changeLogs) | logsByKey: AGENT_SEARCH_KEYS_CONFIG; as logs) {
                            <ag-crm-agent-info-change-log
                              [changeLogs]="logs"
                              [oldData]="changeLogsData?.['oldData']"
                            ></ag-crm-agent-info-change-log>
                          }
                        }
                        @default {
                          <ng-container
                            *ngIf="changeLogsData?.['newData']?.[AgentKeys.downloadedWasabiPaths] as downloadedWasabiPaths; else defaultAgentTemp">
                            <p class="fw-bold">Media was downloaded.</p>
                            <ag-shr-change-log-downloaded-media-detail
                              [log]="downloadedWasabiPaths"
                            ></ag-shr-change-log-downloaded-media-detail>
                          </ng-container>

                          <ng-template #defaultAgentTemp>
                            <p class="fw-bold">Agent was updated.</p>
                            @if (changeLogs | logsByKey: AGENT_SEARCH_KEYS_CONFIG; as logs) {
                              <ag-crm-agent-info-change-log
                                [changeLogs]="logs"
                                [oldData]="changeLogsData?.['oldData']"
                              ></ag-crm-agent-info-change-log>
                            }
                          </ng-template>
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          @case (ChangeLogsHistoryType.registrant) {
            <ng-container *var="data.documentIds?.registrantGuestDbId as guestId">
              @if (data.wasabiPath | wasabiFile | changeLogsDiff: !!guestId | async; as changeLogsData) {
                @switch (data.action) {
                  @case (DocumentWriteAction.create) {
                    @if (changeLogsData?.['diff']; as changeLogs) {
                      @if (!guestId) {
                        <p class="fw-bold">
                          Registrant was created.
                        </p>
                      } @else {
                        <ng-container
                          *ngTemplateOutlet="
                            guestDetailsTemplate;
                            context: { changeLogs: changeLogs, guestId: guestId, action: data.action }
                          "
                        ></ng-container>
                      }
                    }
                  }
                  @case (DocumentWriteAction.remove) {
                    <p class="fw-bold">
                      Registrant was removed.
                    </p>
                  }
                  @default {
                    @if (changeLogsData?.['diff']; as changeLogs) {
                      @if (!guestId) {
                        @if (changeLogs | logsByKey: RSVP_SEARCH_KEYS_CONFIG; as logs) {
                          <ag-shr-rsvp-change-log [changeLogs]="logs"></ag-shr-rsvp-change-log>
                        }
                        @if (changeLogs | logsByKey: PERSONAL_INFO_SEARCH_KEYS_CONFIG; as logs) {
                          <ag-shr-personal-info-change-log [changeLogs]="logs"></ag-shr-personal-info-change-log>
                        }
                        @if (changeLogs?.[RegistrantKeys.primaryEmailAddress]; as logs) {
                          @switch (data.changedBySource) {
                            <!--  import has empty value in logs-->
                            @case (ChangeSourceType.import) {
                            <p><u>Primary Email Address</u> was imported and set as:</p>
                              <ng-container
                                *ngTemplateOutlet="emailTmpl; context: { value: changeLogsData?.['newData']?.['data']?.[RegistrantKeys.primaryEmailAddress] }"></ng-container>
                            }
                            @default {
                              <p><u>Primary Email Address</u> was set as:</p>
                              <ng-container *ngTemplateOutlet="emailTmpl; context: { value: logs }"></ng-container>
                            }
                          }
                          <ng-template #emailTmpl let-value="value">
                            <ag-shr-change-log-email-detail
                              [log]="value"
                            ></ag-shr-change-log-email-detail>
                          </ng-template>
                        }
                        @if (changeLogs?.[RegistrantKeys.chairmanExtension]; as logs) {
                          <ag-shr-chairman-extension-log-details
                            [changeLogs]="getChangedLog(logs)"
                            [attendeeName]="registrantDbId | lookupDescriptionText: agentsLookupSig()"
                          ></ag-shr-chairman-extension-log-details>
                        }
                        @if (changeLogs?.[RegistrantKeys.selectedExcursions]; as logs) {
                          <ag-shr-excursions-change-log
                            [changeLogs]="getChangedLog(logs)"
                            [attendeeName]="registrantDbId | lookupDescriptionText: agentsLookupSig()"
                            [conference]="changesHistoryGridService.conferenceSig()"
                          ></ag-shr-excursions-change-log>
                        }
                        @if (changeLogs?.[RegistrantKeys.flightInformation]; as logs) {
                          <ag-shr-flight-info-change-log
                            [changeLogs]="getChangedLog(logs)"
                            [agentsLookup]="agentsLookupSig()"
                            [attendeeName]="registrantDbId | lookupDescriptionText: agentsLookupSig()"
                          ></ag-shr-flight-info-change-log>
                        }
                        @if (changeLogs?.[RegistrantKeys.hotelReservation]; as logs) {
                          <ag-shr-hotel-reservation-change-log
                            [changeLogs]="getChangedLog(logs)"
                            [agentsLookup]="agentsLookupSig()"
                            [attendeeName]="registrantDbId | lookupDescriptionText: agentsLookupSig()"
                          ></ag-shr-hotel-reservation-change-log>
                        }
                      } @else {
                        <ng-container
                          *ngTemplateOutlet="
                            guestDetailsTemplate;
                            context: { changeLogs: changeLogs, guestId: guestId, action: data.action }
                          "
                        ></ng-container>
                      }
                    }
                  }
                }
              }
            </ng-container>
          }
        }
      }
    </div>

    <!-- Templates -->
    <div *dxTemplate="let cell of 'updatedByCellTemplate'">
      @if (cell.value | lookupDescriptionText: agentsLookupSig(); as displayValue) {
        <span [innerHTML]="displayValue | highlightFilterSearchTerm: (filterPanelText$ | async)"></span>
      }
    </div>

    <div *dxTemplate="let cell of 'updatedFieldsCellTemplate'">
      @for (item of [cell.value]; track $index) {
        <p class="ag-changes-history__grid-row text-wrap"
           *var="item | changeLogFieldsName: changeLogTypeSig() as fields">
          <span [innerHTML]="fields | highlightFilterSearchTerm: (filterPanelText$ | async)"></span>
        </p>
      }
    </div>
  </dx-data-grid>
</div>

<ng-template #guestDetailsTemplate let-changeLogs="changeLogs" let-guestId="guestId" let-action="action">
  <ng-container *var="guestId | lookupDescriptionText: registrantGuestsLookupSig() as guestName">
    <ag-shr-guests-change-log
      [action]="action"
      [guestName]="guestName"
      [changeLogs]="getChangedLog(changeLogs) | logsByKey: GUESTS_SEARCH_KEYS_CONFIG"
    ></ag-shr-guests-change-log>

    <ng-container *ngIf="changeLogs?.[GuestKeys.selectedExcursions] as logs">
      <ag-shr-excursions-change-log
        *ngIf="hasSelectedExcursion(logs)"
        [changeLogs]="getChangedLog(logs)"
        [attendeeName]="guestName"
        [conference]="changesHistoryGridService.conferenceSig()"
      ></ag-shr-excursions-change-log>
    </ng-container>

    <ng-container *ngIf="changeLogs?.[GuestKeys.flightInformation] as logs">
      <ag-shr-flight-info-change-log
        [changeLogs]="getChangedLog(logs)"
        [agentsLookup]="registrantGuestsLookupSig()"
        [attendeeName]="guestName"
      ></ag-shr-flight-info-change-log>
    </ng-container>

    <ng-container *ngIf="changeLogs?.[GuestKeys.chairmanExtSelectedExcursions] as logs">
      <ag-shr-excursions-change-log
        *ngIf="hasSelectedExcursion(logs)"
        [changeLogs]="getChangedLog(logs)"
        [attendeeName]="guestName"
        [caption]="'Chairman Extension: Excursions'"
        [isChairmanExt]="true"
        [conference]="changesHistoryGridService.conferenceSig()"
      ></ag-shr-excursions-change-log>
    </ng-container>
  </ng-container>
</ng-template>

<!-- Not logged with logAgentWrite: -->
<!-- Associations, Status Activity, Need To Knows, Permissions, Media, Campaign -->
